<template>
  <div id="app">
    <VueScroll
      ref="vs"
      :ops="ops"
    >
      <RouterView />
    </VueScroll>
  </div>
</template>

<script>
export default {
  created() {
    // 给body设置成窗口大小,为了虚拟滚动条能够实现
    document.body.style.height = '100%';
  },
  data() {
    return {
      ops: {
        rail: {
          size: '8px',
        },
        bar: {
          background: '#a4a4a4',
          size: '8px',
        },
      },
    };
  },

};
</script>


<style lang="scss">
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  // 给app设置成窗口大小,route-view则可以相对与app这个div滚动
  height: 100%;
  // 文字不能被选中
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
</style>
